<template>
  <div class="certificate-list">
    <div class="certificate-list_empty" v-if="data?.length === 0">暂无资格证书</div>

    <div class="certificate-list_data" v-else>
      <div class="list-box">
        <div class="certificate-item" v-for="(item, index) in data" :key="index">
          {{ item }}

          <div class="item-delete" @click="handleDelete(index)">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: ["data"],

  methods: {
    handleDelete(index) {
      this.$emit("delete", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-list {
  &_data {
    .list-box {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .certificate-item {
        position: relative;
        padding: 6px 16px;
        background: #f5f5f5;
        border-radius: 4px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #3b3b3b;

        .item-delete {
          position: absolute;
          width: 14px;
          height: 14px;
          top: 0;
          right: 0;
          border-radius: 50%;
          background-color: #ff0000;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transform: translate(40%, -40%);
          display: none;

          i {
            display: block;
            font-size: 10px;
            line-height: 10px;
            color: #ffffff;
          }
        }

        &:hover {
          .item-delete {
            display: flex;
          }
        }
      }
    }
  }
}
</style>
